import { render, staticRenderFns } from "./tab-title.vue?vue&type=template&id=6f620c9d&"
import script from "./tab-title.vue?vue&type=script&lang=js&"
export * from "./tab-title.vue?vue&type=script&lang=js&"
import style0 from "./tab-title.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports